import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FilterContainerComponent } from '../report-filters/filter-container/filter-container.component';

@Component({
    selector: 'app-report-anonymous-mode-toggle',
    templateUrl: './report-anonymous-mode-toggle.component.html',
    styleUrls: ['./report-anonymous-mode-toggle.component.scss'],
})
export class ReportAnonymousModeToggleComponent implements OnInit, AfterViewInit
{

    @Input()
    filters: {doBuildAnonymous: boolean} = null;
    @Input()
    container: FilterContainerComponent;

    isChecked = false;

    constructor() {
    }

    ngOnInit() {
        this.container.register(this);
    }

    ngAfterViewInit() {
        this.filters = {doBuildAnonymous: this.isChecked};
        this.container.notifyReady(this);
    }

    notifyParent() {
        this.filters = {doBuildAnonymous: this.isChecked};
        this.container.notifyReady(this);
    }

}
